import React from 'react';
import { useSelector } from 'react-redux';

export function useMarketplaceRequests() {
  const {
    outgoingAccessRequests,
    incomingAccessRequests,
    outgoingListingRequests,
    incomingListingRequests,
  } = useSelector((state: any) => state.domains);

  return {
    outgoingAccessRequests,
    incomingAccessRequests,
    outgoingListingRequests,
    incomingListingRequests,
  };
}
